module.exports = __webpack_public_path__ + "images/scandinavian-3-b355fdad2999a5f91bbc6512dbf8fb8e.jpg";